export const EMAIL_PATTERN = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$';
export const PHONE_NUMBER_PATTERN = '^([0-9]{5,15})$';
export const USERNAME_PATTERN = '^[a-z0-9_.-]+$';
